import {ActionList, Popover} from '@primer/react'
import {useState} from 'react'

import styles from './AccountSwitchDialog.module.css'
import {isActiveAccount, type StashedAccount, StashedAccountItem} from './AccountSwitcher'
import {ErrorDialog, type ErrorDialogProps} from './ErrorDialog'
import type {GlobalUserNavDrawerProps} from './GlobalUserNavDrawer'

export interface AccountSwitchDialogProps extends Pick<GlobalUserNavDrawerProps, 'owner' | 'switchAccountPath'> {
  show?: boolean
  stashedAccounts: StashedAccount[]
}

export function AccountSwitchDialog(props: AccountSwitchDialogProps) {
  const [error, setError] = useState<ErrorDialogProps | false>(false)

  if (!props.show || !props.stashedAccounts?.length || !props.switchAccountPath) {
    return null
  }

  const {stashedAccounts, switchAccountPath} = props

  if (error) {
    return <ErrorDialog {...error} onClose={() => setError(false)} />
  }

  return (
    <Popover className={styles.popover} open>
      <Popover.Content className={styles.popoverContent}>
        <ActionList>
          <ActionList.Heading className={styles.dialogHeader} as="h5">
            <span>Signed in as </span> <span className={styles.accountName}>@{props.owner.login}</span>
          </ActionList.Heading>
          <ActionList.Divider className={styles.divider} />
          <ActionList.Group>
            <ActionList.GroupHeading as="h6">Switch to another account</ActionList.GroupHeading>
            {stashedAccounts.map(account =>
              isActiveAccount(account) ? (
                <StashedAccountItem
                  switchAccountPath={switchAccountPath}
                  account={account}
                  setError={setError}
                  key={account.login}
                />
              ) : null,
            )}
          </ActionList.Group>
        </ActionList>
      </Popover.Content>
    </Popover>
  )
}

try{ AccountSwitchDialog.displayName ||= 'AccountSwitchDialog' } catch {}